import type { ComponentProps } from "react";
import { Select } from "@ark-ui/react";
import Control from "./Control/Control";
import Content from "./Content/Content";
import Item from "./Item/Item";
import Label from "./Label/Label";

type Props<T> = ComponentProps<typeof Select.Root<T>>;

const SelectorRoot = <T,>({ children, ...rest }: Props<T>) => {
  return (
    <Select.Root {...rest}>
      {children}
      <Select.HiddenSelect />
    </Select.Root>
  );
};

export const Selector = Object.assign(SelectorRoot, {
  Control,
  Content,
  Item,
  Label,
});
